exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\np[data-v-2888e551] {\n  font-size: 2em;\n  text-align: center;\n}\n", "", {"version":3,"sources":["/var/www/sgi/sgi/app/javascript/app/javascript/app.vue"],"names":[],"mappings":";AAiBA;EACA,eAAA;EACA,mBAAA;CACA","file":"app.vue?vue&type=style&index=0&id=2888e551&prod&scoped=true&lang=css&","sourcesContent":["<template>\n  <div id=\"app\">\n    <p>{{ message }}</p>\n  </div>\n</template>\n\n<script>\nexport default {\n  data: function () {\n    return {\n      message: \"Hello Vue!\"\n    }\n  }\n}\n</script>\n\n<style scoped>\np {\n  font-size: 2em;\n  text-align: center;\n}\n</style>\n"],"sourceRoot":""}]);

// exports
